module.exports = __webpack_public_path__ + "img/b6e916ae5982d2d3bebca61033ce2e4.73b9509f.png";